import { render, staticRenderFns } from "./appAdminWarnings.vue?vue&type=template&id=60a8fac8&scoped=true"
import script from "./appAdminWarnings.vue?vue&type=script&lang=js"
export * from "./appAdminWarnings.vue?vue&type=script&lang=js"
import style0 from "./appAdminWarnings.vue?vue&type=style&index=0&id=60a8fac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8fac8",
  null
  
)

export default component.exports